import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { GlobalContext } from "./context/global/context";
import { Footer } from "./components/Footer";
import { MainPage } from "./routes/Main";
import { HomePage } from "./routes/Home";
import { AdvancePage } from "./routes/Advance";
import { SecurityPage } from "./routes/Security";
import { SolutionPage } from "./routes/Solution";
import { DeveloperPage } from "./routes/Developer";
import { AboutusPage } from "./routes/Aboutus";
import { PricePage } from "./routes/Price";
import { SSOPage } from "./routes/SSOPage";
import { MultiplePage } from "./routes/Multiple";
import { DatabasePage } from "./routes/Database";
import { VerifyPage } from "./routes/VerifyPage";
import { JoinusPage } from "./routes/Joinus";
import { LogPage } from "./routes/Log";
import { NotFoundPage } from "./routes/NotFound";
import { BlogHomePage } from "./routes/Blog/Home";
import { BlogDetailPage } from "./routes/Blog/Detail";
import { BlogEditPage } from "./routes/Blog/Edit";
import { BlogTagPage } from "./routes/Blog/Tag";
import { BlogPublishPage } from "./routes/Blog/Publish";
import { ActivityPage } from "./routes/Activity";
import { TopicPage } from "./routes/Topic";
import { WechatPage } from "./routes/Wechat";
import { IdaasPage } from "./routes/Idaas";
import { OktaPage } from "./routes/Okta";
// import { ADPage } from "./routes/AD";
import { BuildIdaasPage } from "./routes/BuildIdaas";
import { CognitoPage } from "./routes/Cognito";
import { KeyclockPage } from "./routes/Keyclock";
// import { MfaPage } from "./routes/Mfa";
import { BuildADPage } from "./routes/BuildAD";
// import { Helmet } from "react-helmet";
import { getDefaultLang } from "./utils";
import classnames from "classnames";
import "./App.less";
import { HeighEducatePage } from "./routes/HeighEducate";
import { CustomerPage } from "./routes/Customer";
import { CNPNPage } from "./routes/CNPN";
import { SouthEastPage } from "./routes/SouthEast";
import { XianGongPage } from "./routes/XianGong";
import { DeephowPage } from "./routes/Deephow";
import { BentleyPage } from "./routes/Bentley";
import { TheragunPage } from "./routes/Theragun";
import { PrivateCloudPage } from "./routes/PrivateCloud";
import { FutuPage } from "./routes/Futu";
import { RouterGuard } from "./components/RouterGuard";
import { ApplicationPage } from "./routes/Application";
import { MarketplacePage } from "./routes/Marketplace";
import { MarketplaceDetailPage } from "./routes/MarketplaceDetail";
import { GatewayIntegrationPage } from "./routes/Gateway";
import { CloudOriginal } from "./routes/CloudOriginal";
// import { PrivateCloudPricePage } from "./routes/PrivateCloudPrice";
import querystring from "query-string";
import { GuardPage } from "./routes/Guard";
import { HelloPage } from "./routes/hello";

// let main = () => {
//   let r = typeof window !== "undefined";
//   if (!r) {
//     return;
//   }
//   window.onload = () => {
//     // useEffect(() => {
//     // 读取并写入 sessionStorage
//     let search = querystring.parse(window.location.search);
//     Object.keys(search).forEach((k) => {
//       let v = search[k];
//       console.log("写入时", k, v);
//       sessionStorage.setItem(k, v);
//     });
//     //   }, []);
//   };
// };

// main();

function App(props) {
  const lang = props.lang || getDefaultLang();
  const initData = props.initData;
  const isMobile = props.initData?.isMobile ? props.initData.isMobile : null;
  // const isMobile = "mobile";
  // const { pathname } = useLocation();

  useEffect(() => {
    // 读取并写入 sessionStorage
    let search = querystring.parse(
      typeof window !== "undefined" && window.location.search
    );
    // console.log(search["utm_source"]);
    // document.cookie = `utm_source=${search["utm_source"]}`;
    Object.keys(search).forEach((k) => {
      let v = search[k];
      // console.log("写入时", k, v);
      sessionStorage.setItem(k, v);
    });
  }, []);

  return (
    <GlobalContext value={{ lang, userInfo: null, isMobile: isMobile }}>
      <div className={classnames(["App", `lang-${lang}`])}>
        <Routes>
          <Route
            path="/"
            element={
              <RouterGuard mobileMeta={true}>
                <HomePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/login"
            element={
              <RouterGuard>
                <MainPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/advantage"
            element={
              <RouterGuard>
                <AdvancePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/security"
            element={
              <RouterGuard>
                <SecurityPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solution"
            element={
              <RouterGuard>
                <SolutionPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions*"
            element={
              <RouterGuard>
                <SolutionPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/wechat"
            element={
              <RouterGuard>
                <WechatPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/idaas"
            element={
              <RouterGuard>
                <IdaasPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/okta"
            element={
              <RouterGuard>
                <OktaPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route path="/solutions/ad" element={<ADPage {...initData} />} /> */}
          <Route
            path="/solutions/build-idaas"
            element={
              <RouterGuard>
                <BuildIdaasPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/cognito"
            element={
              <RouterGuard>
                <CognitoPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/keycloak"
            element={
              <RouterGuard>
                <KeyclockPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/solutions/mfa"
            element={
              <RouterGuard>
                <MfaPage {...initData} />
              </RouterGuard>
            }
          /> */}
          <Route
            path="/solutions/ad"
            element={
              <RouterGuard>
                <BuildADPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer"
            element={
              <RouterGuard>
                <CustomerPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/hep"
            element={
              <RouterGuard>
                <HeighEducatePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/cnpn"
            element={
              <RouterGuard>
                <CNPNPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/southeast-university"
            element={
              <RouterGuard>
                <SouthEastPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/xian-gong"
            element={
              <RouterGuard>
                <XianGongPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/deephow"
            element={
              <RouterGuard>
                <DeephowPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/theragun"
            element={
              <RouterGuard>
                <TheragunPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/bentley"
            element={
              <RouterGuard>
                <BentleyPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/customer/futu"
            element={
              <RouterGuard>
                <FutuPage {...initData} />
              </RouterGuard>
            }
          />

          <Route
            path="/developer"
            element={
              <RouterGuard>
                <DeveloperPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/about"
            element={
              <RouterGuard>
                <AboutusPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/pricing"
            element={
              <RouterGuard>
                <PricePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/learn/guard"
            element={
              <RouterGuard mobileMeta={true}>
                <GuardPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/mfa"
            element={
              <RouterGuard mobileMeta={true}>
                <MultiplePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/database-connection"
            element={
              <RouterGuard>
                <DatabasePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/gateway-integration"
            element={
              <RouterGuard mobileMeta={true}>
                <GatewayIntegrationPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/cloud-native"
            element={
              <RouterGuard mobileMeta={true}>
                <CloudOriginal {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/learn/sso"
            element={
              <RouterGuard mobileMeta={true}>
                <SSOPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/verify"
            element={
              <RouterGuard mobileMeta={true}>
                <VerifyPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/joinus*"
            element={
              <RouterGuard>
                <JoinusPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/changelog"
            element={
              <RouterGuard>
                <LogPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/error/404"
            element={
              <RouterGuard>
                <NotFoundPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog"
            element={
              <RouterGuard>
                <BlogHomePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/topic"
            element={
              <RouterGuard>
                <TopicPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/activity"
            element={
              <RouterGuard>
                <ActivityPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/solutions/private-cloud"
            element={
              <RouterGuard>
                <PrivateCloudPage {...initData} />
              </RouterGuard>
            }
          />
          {/* <Route
            path="/private-cloud-price"
            element={<PrivateCloudPricePage {...initData} />}
          /> */}

          <Route
            path="/blog/detail/:id"
            element={
              <RouterGuard>
                <BlogDetailPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog/edit/:id"
            element={
              <RouterGuard>
                <BlogEditPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog/tag/:id"
            element={
              <RouterGuard>
                <BlogTagPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/blog/publish"
            element={
              <RouterGuard>
                <BlogPublishPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/apn/intro"
            element={
              <RouterGuard mobileMeta={true}>
                <ApplicationPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/apn"
            element={
              <RouterGuard mobileMeta={true}>
                <MarketplacePage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/apn/detail/:id"
            element={
              <RouterGuard mobileMeta={true}>
                <MarketplaceDetailPage {...initData} />
              </RouterGuard>
            }
          />
          <Route
            path="/welcome"
            element={
              <RouterGuard>
                <HelloPage {...initData} />
              </RouterGuard>
            }
          />
        </Routes>
        {/* {!NO_FOOTER.includes(pathname) && <Footer />} */}
      </div>
    </GlobalContext>
  );
}

export default App;
